module.exports = __webpack_public_path__ + "img/RX-RAD-DIGI-Sala-12.b3cf5826.png";